<div
  class="loading-component d-flex flex-column fixed-top w-100 h-100 justify-content-center align-items-center"
  [class.busy]="busy"
>
  <div class="position-relative">
    <div class="overlay-loader">
      <img class="loader-icon spinning-cog" src="assets/images/spinning-cog.svg" height="48" alt="spinning" />
    </div>
    <h5 class="mt-3 fw-normal position-relative user-select-none">{{ text }}</h5>
    @if (cancelable) {
      <button type="button" class="btn btn-danger mt-4" (click)="cancelLoading.emit()">
        {{ cancelButtonText }}
      </button>
    }
  </div>
</div>
